import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  ActivityCard,
  FooterNote,
  GoalProgressBar,
  PrimaryButton,
  ScreenShell,
  ScreenTitle,
  SecondaryButton,
  tokens,
} from '../parts';
import { ActivityForm } from './ActivityForm';
import { GoalFlowScreenProps } from './types';

/** Add another activity, or edit one — with the goal so far listed below the form. */
export const BuildScreen: React.FC<GoalFlowScreenProps> = ({ goalFlow }) => (
  <ScreenShell
    onClose={goalFlow.requestClose}
    footer={
      <>
        {(goalFlow.canAddMore || goalFlow.isEditing) && (
          <PrimaryButton onClick={goalFlow.submitForm} disabled={!goalFlow.canSubmit}>
            {goalFlow.isEditing ? 'Save Changes' : 'Add This Activity'}
          </PrimaryButton>
        )}
        {/* Without this the only way off this screen is X, which discards the whole goal. */}
        {goalFlow.activityCount > 0 && <SecondaryButton onClick={goalFlow.review}>Review SMART Goal</SecondaryButton>}
        <FooterNote maxActivities={goalFlow.maxActivities} />
      </>
    }
  >
    <Box sx={{ mb: 2 }}>
      <ScreenTitle>Set Your SMART Goal</ScreenTitle>
      <Typography sx={{ fontSize: '15px', color: tokens.textPrimary, mt: 0.25 }}>
        Add another activity, or review your SMART goal.
      </Typography>
    </Box>
    <Box sx={{ mb: 2.5 }}>
      <GoalProgressBar completed={goalFlow.buildProgress} total={goalFlow.maxActivities} />
    </Box>
    {(goalFlow.canAddMore || goalFlow.isEditing) && <ActivityForm goalFlow={goalFlow} />}
    {goalFlow.buildCards.length > 0 && (
      <>
        <Box sx={{ display: 'flex', alignItems: 'center', py: 1.5, mt: 2, mb: 1.5 }}>
          <Box sx={{ flex: 1, borderTop: `1px dashed ${tokens.border}` }} />
          <Typography sx={{ mx: 1.5, fontSize: '13px', color: tokens.textPrimary, fontWeight: 500 }}>
            activities in your SMART goal
          </Typography>
          <Box sx={{ flex: 1, borderTop: `1px dashed ${tokens.border}` }} />
        </Box>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 600,
            color: tokens.label,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            mb: 1.5,
          }}
        >
          Your SMART Goal So Far
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {goalFlow.buildCards.map((card) => (
            <ActivityCard
              key={card.index}
              card={card}
              label={`Activity ${card.index + 1}`}
              onEdit={() => goalFlow.edit(card.index)}
              onDelete={() => goalFlow.requestDelete(card.index)}
            >
              <Typography sx={{ fontSize: '15px', fontWeight: 600, color: tokens.textPrimary }}>{card.name}</Typography>
              <Typography sx={{ fontSize: '13px', color: tokens.textPrimary }}>
                {card.frequency}× per week · {card.duration} min
              </Typography>
            </ActivityCard>
          ))}
        </Box>
      </>
    )}
  </ScreenShell>
);
